import { render } from "./EventDetails.vue?vue&type=template&id=31855b9e&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=31855b9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31855b9e"

export default script